<!--test.vue-->
<template>
  <div class="Ds-banner">
    <img draggable="false" :src="imageSrc" alt="" v-if="imageSrc">
    <img draggable="false" :src="randomImageSrc" alt="" v-else>
  </div>
</template>

<script>
	export default {
    name: 'DsBanner',
    data() {
      return {
        url:[
          'https://www.qmx.top//upload/2023/12/08/20231208155219012pIi0LEdN.jpg',
          'https://www.qmx.top//upload/2023/12/08/20231208162934012n05893i6.jpg'
        ]
      }
    },
		props: {
			imageSrc: {
        type: String,
        default:''
      }
    },
    computed: {
        randomImageSrc(){
          let i=Math.floor(Math.random() * this.url.length)
          return this.url[i]
        }
    }
	}
</script>

<style lang="scss" scoped>
  .Ds-banner{
    width: 100%;
    height: 100%;
  }
  img{
    display: block;
    width: 100%;
    height: 100%;
  }
</style>
